import { render, staticRenderFns } from "./userZhang.vue?vue&type=template&id=20d2c54e&"
import script from "./userZhang.vue?vue&type=script&lang=js&"
export * from "./userZhang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports